import React, { useEffect, useRef } from 'react'

import type { Guide } from '../../../../LaunchStrategy.types'
import arrowIcon from '../../assets/arrow.svg'
import * as S from './GuidesList.styled'

type GuidesListProps = {
  guides: Guide[]
  categoryIndex: number
  activeGuideIndex: number
  activeCategoryIndex: number
  onChange: (categoryIndex: number, guideIndex: number) => void
  onGuideSelect?: () => void
}

export const GuidesList = ({
  guides,
  categoryIndex,
  activeCategoryIndex,
  activeGuideIndex,
  onChange,
  onGuideSelect,
}: GuidesListProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.style.height =
        activeCategoryIndex === categoryIndex ? `${containerRef.current.scrollHeight}px` : `0px`
      containerRef.current.style.transitionProperty = 'height'
    }
  }, [activeCategoryIndex, categoryIndex])

  return (
    <S.Container ref={containerRef} initiallyCollapsed={activeCategoryIndex !== categoryIndex}>
      {guides.map((guide, guideIndex) => (
        <S.GuideButton
          withIndicator={activeCategoryIndex === categoryIndex && guideIndex <= activeGuideIndex}
          key={`guide${categoryIndex}${guideIndex}`}
          active={activeCategoryIndex === categoryIndex && activeGuideIndex === guideIndex}
          onClick={() => {
            onGuideSelect?.()
            onChange(categoryIndex, guideIndex)
          }}
        >
          <S.ArrowIcon>
            <img src={arrowIcon} />
          </S.ArrowIcon>
          {guide.title}
        </S.GuideButton>
      ))}
    </S.Container>
  )
}
